<template>
  <div :class="[bemClass(), hasValueClass, focusClass]">
    <div :class="bemClass('wrap')">
      <label :class="bemClass('label')" :for="selectId">
        <slot></slot>
      </label>
      <div :class="bemClass('el-wrap')">
        <select
          v-bind="attrs"
          :name="name"
          :id="selectId"
          @blur="blur"
          @focus="focus"
          @input="input"
          :class="bemClass('el')">
          <slot name="empty-option"></slot>
          <template v-if="options.length">
            <option
              v-for="(option, index) in options"
              :key="name + index"
              :value="option.value"
              :selected="(modelValue === option.value)">
              {{ option.label }}
            </option>
          </template>
        </select>
        <slot name="icon"></slot>
      </div>
      <template v-if="!isValid">
        <transition name="fade">
          <p :class="bemClass('error-message')">{{ validateMessage }}</p>
        </transition>
      </template>
    </div>
  </div>
</template>

<script>
import { computed, ref, toRefs, watch } from 'vue'
import useBem from '../../compositions/bem'
import useAttrs from '../../compositions/use-attrs'
import { selGenUniqueId } from '../../util/util'

export default {
  name: 'SelSelect',
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    required: {
      type: Boolean,
      default: false
    },
    validateFn: Function,
    errorMessage: {
      type: String,
      default: ''
    },
    modifier: {
      type: String,
      default: ''
    }
  },
  setup (props, { emit }) {
    const { modifier, modelValue } = toRefs(props)
    const attrs = useAttrs()
    const { bemClass } = useBem('sel-select', modifier)
    const selectId = `select-${selGenUniqueId()}`
    const isFocused = ref(false)
    const hasValue = computed(() => (props.modelValue && props.modelValue.length !== 0))

    const hasValueClass = computed(() => hasValue.value ? 'has-value' : '')
    const focusClass = computed(() => isFocused.value ? 'is-focused' : '')

    const isValid = ref(true)
    const validateMessage = computed(() => props.errorMessage ? props.errorMessage : 'Field is required')

    watch(modelValue, () => {
      validate()
    })

    const validate = () => {
      if (props.required) {
        isValid.value = !!modelValue.value
      }
      if (props.validateFn) {
        isValid.value = props.validateFn(modelValue.value)
      }
      return isValid.value
    }

    function input ($event) {
      emit('update:modelValue', $event.target.value)
    }

    const focus = ($event) => {
      isFocused.value = true
    }

    const blur = () => {
      isFocused.value = false
      validate()
    }

    return {
      bemClass,
      attrs,
      input,
      focus,
      blur,
      isFocused,
      hasValueClass,
      focusClass,
      selectId,
      isValid,
      validateMessage
    }
  }
}
</script>
